import galleryData from "../data/galleryData";

export const getGallery = async () => {
  return galleryData;
};

export const getGalleryById = async (id) => {
  const gallery = galleryData.find((g) => g.id === id);
  return gallery || null;
};